<script>
import WebLayout from '@/layouts/Web/Layout.vue'

export default {
    layout: WebLayout,
}
</script>
<script setup>
import { computed } from 'vue'
import SEOHead from '@/components/SEOHead.vue'
import { useWebTranslations } from '@/composables/useWebTranslations.js'

const { get, locale, webRoute, alternateLocales } = useWebTranslations()
const base = 'static.impressum'
const seoTitle = computed(() => `${get(`${base}.seo_title`)}`)
const seoDescription = computed(() => get(`${base}.seo_description`))
const canonicalPath = computed(() => webRoute('web.impressum'))
const pageAlternateLocales = computed(() => alternateLocales('web.impressum'))
</script>

<template>
    <SEOHead
        :title="seoTitle"
        :description="seoDescription"
        :keywords="get(`${base}.seo_keywords`)"
        :canonical="canonicalPath"
        :locale="locale"
    :alternate-locales="pageAlternateLocales"
        image="/images/web/growiyo-impressum.png"
        :structured-data="{
            '@type': 'WebSite',
            'name': 'Growiyo.com',
            'url': 'https://growiyo.com',
            'description': seoDescription,
        }"
        type="website"
    />
    <div class="container mx-auto px-4 py-12">
        <div class="max-w-4xl mx-auto">
            <h1 class="text-4xl font-bold text-growiyo-dark mb-8 text-center">{{ get(`${base}.title`) }}</h1>

            <div class="prose prose-lg max-w-none">
                <div class="bg-growiyo-light border-l-4 border-growiyo-pink p-6 mb-8 rounded-r-lg shadow-sm">
                    <h2 class="text-2xl font-semibold text-growiyo-dark mb-4">{{ get(`${base}.intro_title`) }}</h2>
                    <p class="text-iron-grey mb-0">
                        {{ get(`${base}.website_label`) }} <a href="https://growiyo.com" target="_blank" rel="noopener noreferrer" class="text-growiyo-pink hover:underline">https://growiyo.com</a>
                    </p>
                </div>

                <div class="flex flex-wrap gap-x-6 gap-y-1 mb-10 text-sm text-iron-grey border-b border-gray-200 pb-6">
                    <span><strong class="text-growiyo-dark">{{ get(`${base}.updated`) }}</strong> {{ get(`${base}.meta_date`) }}</span>
                    <span><strong class="text-growiyo-dark">{{ get(`${base}.provider`) }}</strong> {{ get(`${base}.meta_provider`) }}</span>
                    <span><strong class="text-growiyo-dark">{{ get(`${base}.brand`) }}</strong> {{ get(`${base}.meta_brand`) }}</span>
                </div>

                <section class="mb-10">
                    <h2 class="text-2xl font-semibold text-growiyo-dark mt-8 mb-4">{{ get(`${base}.section_operator_title`) }}</h2>
                    <p class="text-iron-grey mb-2"><strong class="text-growiyo-dark">Growiyo</strong></p>
                    <div class="space-y-2 text-iron-grey">
                        <p><span class="font-medium text-growiyo-dark">{{ get(`${base}.company_name`) }}</span><br>{{ get(`${base}.company_value`) }}</p>
                        <p><span class="font-medium text-growiyo-dark">{{ get(`${base}.owner_name`) }}</span><br>{{ get(`${base}.owner_value`) }}</p>
                        <p><span class="font-medium text-growiyo-dark">{{ get(`${base}.address_label`) }}</span><br><span v-html="get(`${base}.address_value`)"></span></p>
                        <p><span class="font-medium text-growiyo-dark">{{ get(`${base}.id_number`) }}</span> {{ get(`${base}.id_value`) }}<br><span class="font-medium text-growiyo-dark">{{ get(`${base}.tax_number`) }}</span> {{ get(`${base}.tax_value`) }}</p>
                    </div>
                </section>

                <section class="mb-10">
                    <h2 class="text-2xl font-semibold text-growiyo-dark mt-8 mb-4">{{ get(`${base}.contact_title`) }}</h2>
                    <p class="text-iron-grey mb-2"><span class="font-medium text-growiyo-dark">{{ get(`${base}.email_label`) }}</span> <a href="mailto:info@growiyo.com" class="text-growiyo-pink hover:underline">info@growiyo.com</a></p>
                    <p class="text-iron-grey mb-2"><span class="font-medium text-growiyo-dark">{{ get(`${base}.phone_label`) }}</span> {{ get(`${base}.phone_value`) }}</p>
                    <p class="text-iron-grey"><span class="font-medium text-growiyo-dark">{{ get(`${base}.activity_label`) }}</span> {{ get(`${base}.activity_value`) }}</p>
                </section>

                <section class="mb-10">
                    <h2 class="text-2xl font-semibold text-growiyo-dark mt-8 mb-4">{{ get(`${base}.content_responsible_title`) }}</h2>
                    <p class="text-iron-grey">{{ get(`${base}.content_responsible_value`) }}</p>
                </section>

                <div class="mt-12 pt-6 border-t border-gray-200">
                    <p class="text-sm text-iron-grey-light text-center">
                        {{ get(`${base}.last_updated`) }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
